import React, {useContext, useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Header from "./Common/Header";
import Home from "../pages/Home";
import Messaging from "../pages/Messaging";
import NotFound from "../pages/NotFound";
import Footer from "./Common/Footer";
import Forbidden from "../pages/Error/Forbidden";
import {UNREAD_CHECK_EVENT} from "../services/events";
import {getNewConversationsCount} from "../services/api/messaging";
import {AuthContext} from "../context/AuthContext";
import AdminConversations from "../pages/Admin/Conversation/AdminConversations";
import AdminConversationDetail from "../pages/Admin/Conversation/AdminConversationDetail";
import AdminHeader from "../pages/Admin/AdminHeader";
import ReviewsList from "../pages/Marketing/ClientReviews/ReviewsList";
import BrokerDetails from "../pages/Admin/Brokers/BrokerDetails";
import MAVPage from "../pages/Admin/Marketing/MAVTable";
import BrokerUpdateRequests from "../pages/Broker/Account/BrokerUpdateRequests";
import AdminVendorList from "../pages/Admin/Vendors/AdminVendorList";
import AdminVendorAffiliateList from "../pages/Admin/Vendors/AdminVendorAffiliateList";
import AdminVendorDetail from "../pages/Admin/Vendors/AdminVendorDetail";
import DashboardPage from "../pages/Marketing/Dashboard/DashboardPage";
import AffiliateClicks from "../pages/Admin/Affiliate/AffiliateClicks";
import ContactsPage from "../pages/Vendor/ContactsPage";
import FileDownloadPage from "../pages/File/Download";
import Webinars from "../pages/Broker/Webinars/Webinars";
import BrokersSearchFeatureList from "../pages/Admin/Brokers/BrokersSearchFeatureList";
import BrokerFeatures from "../pages/Admin/Brokers/BrokerFeatures";
import VendorFeatures from "../pages/Admin/Vendors/VendorFeatures";
import AdminFeatures from "../pages/Admin/AdminFeatures";
import AdminProductThesaurus from "../pages/Admin/Product/AdminProductThesaurus";
import AdminProductSpecificQuestions from "../pages/Admin/Product/AdminProductSpecificQuestions";
import AdminPlatformFlagList from "../pages/Admin/Vendors/AdminPlatformFlagList";
import ReportsList from "../pages/Admin/Reports/ReportsList";
import AccountsTable from "../pages/Admin/SSOAccounts/AccountsTable";
import MergedAccountsTable from "../pages/Admin/SSOAccounts/MergedAccountsTable";
import AdminEnvironment from "../pages/Admin/Environment/AdminEnvironment";


const RouterBase = () => {

    const [newMessageCount, setNewMessageCount] = useState(0);
    const {baseUrl, company, accountType, ...data} = useContext(AuthContext);
    const isAdmin = data?.is_admin;

    useEffect(() => {
        const fetchNewConversationsCount = async () => {
            try {
                const result = await getNewConversationsCount();
                setNewMessageCount(result?.total);
            } catch (error) {
                console.error('Error fetching new conversations count:', error);
            }
        };
        fetchNewConversationsCount();
        const unreadCheckEvent = () => {
            fetchNewConversationsCount();
        };

        document.addEventListener(UNREAD_CHECK_EVENT, unreadCheckEvent);

        return () => {
            document.removeEventListener(UNREAD_CHECK_EVENT, unreadCheckEvent);
        };
    }, []);

    return (
        <div>
            <Router>
                {isAdmin ? (
                    <AdminHeader baseUrl={baseUrl} user={data}/>
                ) : (
                    <Header user={data} baseUrl={baseUrl} company={company} newMessages={newMessageCount}/>
                )}

                <main className="sl-main sl-mt-8">
                    <Routes>
                        <Route exact path="/" element={<Home/>}/>
                        <Route exact path="/admin" element={<AdminFeatures/>}/>
                        <Route exact path="/admin/reports" element={<ReportsList/>}/>
                        <Route exact path="/admin/brokers/:id"
                               element={<BrokerDetails/>}/>
                        <Route exact path="/admin/brokers/:page?/:per_page?" element={<BrokerFeatures/>}/>
                        <Route exact path="/admin/brokers/searchfeature/:page?/:per_page?"
                               element={<BrokersSearchFeatureList/>}/>
                        <Route exact path="/admin/marketing/mav/:page?/:per_page?" element={<MAVPage/>}/>
                        <Route exact path="/admin/conversations/:status?/:page?/:per_page?"
                               element={<AdminConversations/>}/>
                        <Route exact path="/admin/thesaurus/:product?/:page?/:per_page?"
                               element={<AdminProductThesaurus/>}/>
                        <Route exact path="/admin/psq/:product?/:page?/:per_page?"
                               element={<AdminProductSpecificQuestions/>}/>
                        <Route exact path="/admin/environment/:page?/:per_page?"
                               element={<AdminEnvironment/>}/>
                        <Route exact path="/broker/update-requests/:status?/:page?/:per_page?"
                               element={<BrokerUpdateRequests/>}/>
                        <Route exact path="/admin/conversation/:id/:page?/:per_page?"
                               element={<AdminConversationDetail/>}/>
                        <Route exact path="/admin/vendors/:page?/:per_page?" element={<VendorFeatures/>}/>
                        <Route exact path="/admin/vendors/dashboard/:page?/:per_page?" element={<AdminVendorList/>}/>
                        <Route exact path="/admin/vendors/affiliate/:page?/:per_page?"
                               element={<AdminVendorAffiliateList/>}/>
                        <Route exact path="/admin/vendors/platform/:page?/:per_page?"
                               element={<AdminPlatformFlagList/>}/>

                        <Route exact path="/admin/vendor/:id"
                               element={<AdminVendorDetail/>}/>
                        <Route exact path="/admin/affiliate_clicks/:page?/:per_page?"
                               element={<AffiliateClicks/>}/>


                        <Route exact path="/admin/duplicate_accounts/:page?/:per_page?"
                               element={<AccountsTable/>}/>

                        <Route exact path="/admin/merged_accounts/:page?/:per_page?"
                               element={<MergedAccountsTable/>}/>

                        <Route exact path="/broker/webinars/:product?/:id?/:page?/:per_page?"
                               element={<Webinars/>}/>

                        <Route exact path="/messaging"
                               element={<Messaging newMessages={newMessageCount} authData={data}/>}/>
                        <Route path="*" element={<NotFound/>}/>
                        <Route exact path="/error/403" element={<Forbidden/>}/>
                        {/*vendor routes*/}
                        <Route exact path="/vendor/:vendorSlug/marketing/client-reviews" element={<ReviewsList/>}/>
                        {company?.has_dashboard &&
                            <Route exact path="/vendor/:vendorSlug/dashboard" element={<DashboardPage/>}/>}


                        <Route exact path="/vendor/contacts"
                               element={<ContactsPage/>}/>

                        <Route exact path="/file/download/:location"
                               element={<FileDownloadPage/>}/>
                    </Routes>

                </main>

                <Footer accountType={accountType}/>
            </Router>
        </div>
    );
};
export default RouterBase;
